"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _api = _interopRequireWildcard(require("../api"));

var _mobx = require("mobx");

var _get = _interopRequireDefault(require("lodash/get"));

var _snakeCase = _interopRequireDefault(require("lodash/snakeCase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var StaticData = /*#__PURE__*/function () {
  function StaticData() {
    var _this = this;

    _classCallCheck(this, StaticData);

    _defineProperty(this, "getEPLStatusesColors", function () {
      return {
        red: [_this.CONST.EPL_STATUSES.NOT_AVAILABLE, _this.CONST.EPL_STATUSES.NOT_APPROVED, _this.CONST.EPL_STATUSES.REJECTED],
        orange: [_this.CONST.EPL_STATUSES.RECRUITMENT],
        green: [_this.CONST.EPL_STATUSES.FOR_MANAGER_APPROVAL, _this.CONST.EPL_STATUSES.SUBMITTED, _this.CONST.EPL_STATUSES.REQUESTED, _this.CONST.EPL_STATUSES.SCHEDULED, _this.CONST.EPL_STATUSES.NOT_INTERVIEWED, _this.CONST.EPL_STATUSES.INTERVIEWED]
      };
    });

    _defineProperty(this, "getStatusColor", function (eplStatusId) {
      var statusColorMap = _this.getEPLStatusesColors();

      var colors = Object.keys(statusColorMap);
      var color = colors.find(function (color) {
        return statusColorMap[color].includes(eplStatusId);
      });
      return color;
    });

    _defineProperty(this, "decorateWithConstAndNames", function (data) {
      var resources = ['accountTypes', 'conditions', 'contractCategories', 'contractConditions', 'contractCoverages', 'contractStatuses', 'contractPriorities', 'contractTypes', 'contractTypeDetails', 'countries', 'currencies', 'employeePositions', 'eplStatuses', 'industries', 'invoicingCoverages', 'invoiceStatuses', 'languageProficiencies', 'languages', 'permissions', 'phoneTypes', 'projectStatuses', 'projectTypes', 'projectRequiredResources', 'subIndustries', 'timezones', 'eplOutputTypes', 'expertFocusRegions', 'expertStatuses', 'eplPreliminaryTags', 'eplReplyStatusComments', 'deliverableTypes', 'feeTypes', 'paymentServiceTypes', 'paymentTransferMethods', 'costTypes', 'paymentStatuses', 'expertPaymentDetailStatuses', 'eplStatusComments', 'vatClasses', 'pricings', 'replyStatuses', 'invoiceTypes', 'taxTypes', 'invoicePaymentStatuses', 'userTypes', 'complianceTypes'];
      var CONST = {};
      data.names = {};
      resources.forEach(function (resource) {
        data.names[resource] = {};
        var constCat = (0, _snakeCase["default"])(resource).toUpperCase();
        CONST[constCat] = {};
        data[resource].forEach(function (item) {
          if (item.name) {
            data.names[resource][item.id] = item.name;
            CONST[constCat][(0, _snakeCase["default"])(item.name).toUpperCase()] = item.id;
          }
        });
      });
      data.names['badges'] = {};
      data.badges.forEach(function (b) {
        data.names['badges'][b.id] = b.name;
      });
      data.CONST = CONST;
      return data;
    });

    this.CONST = null;
    (0, _mobx.extendObservable)(this, {
      staticData: null,
      EPLStatusesColors: (0, _mobx.computed)(this.getEPLStatusesColors),
      loading: false,
      error: null
    });
    this.loadData();
  }

  _createClass(StaticData, [{
    key: "loadData",
    value: function loadData() {
      var _this2 = this;

      this.loading = true;
      this.getData().then(function (res) {
        var staticData = (0, _api.extractData)(res);
        staticData = _this2.decorateWithConstAndNames(staticData);
        Object.assign(_this2, staticData);
        _this2.staticData = staticData;
        _this2.loading = false;
      })["catch"](function (err) {
        _this2.error = err;
      });
    }
  }, {
    key: "getData",
    value: function getData() {
      return _api["default"].get('/api/static-data');
    }
    /*
          This works when there's array with fields:
          - id, name
          in staticData
      */

  }, {
    key: "getDataFromArray",
    value: function getDataFromArray(id, arr) {
      if (!id || !arr || !this[arr]) return null;
      return this[arr].find(function (item) {
        return item.id === id;
      }).name;
    }
  }, {
    key: "getFullDataFromArray",
    value: function getFullDataFromArray(id, arr) {
      if (!id || !arr || !this[arr]) return null;
      return this[arr].find(function (item) {
        return item.id === id;
      });
    }
  }, {
    key: "renderCountry",
    value: function renderCountry(countryId) {
      var countryNames = (0, _get["default"])(this.staticData, 'names.countries', {});
      return countryNames[countryId];
    }
  }, {
    key: "renderTimezone",
    value: function renderTimezone(timezoneId) {
      var timezoneNames = (0, _get["default"])(this.staticData, 'names.timezones', {});
      return timezoneNames[timezoneId];
    }
  }, {
    key: "renderPhoneType",
    value: function renderPhoneType(phoneTypeId) {
      var phoneTypeNames = (0, _get["default"])(this.staticData, 'names.phoneTypes', {});
      return phoneTypeNames[phoneTypeId];
    }
  }, {
    key: "getHonorariumCurrencyOptions",
    value: function getHonorariumCurrencyOptions() {
      var _this$staticData$CONS = this.staticData.CONST.CURRENCIES,
          EUR = _this$staticData$CONS.EUR,
          USD = _this$staticData$CONS.USD,
          CNY = _this$staticData$CONS.CNY,
          GBP = _this$staticData$CONS.GBP;
      var honorariumCurrencies = this.staticData.currencies.filter(function (c) {
        return [EUR, USD, CNY, GBP].includes(c.id);
      });
      return honorariumCurrencies;
    }
  }, {
    key: "getClientProjectFeedbackQuestions",
    value: function getClientProjectFeedbackQuestions(projectType) {
      var _this$staticData$CONS2 = this.staticData.CONST.PROJECT_TYPES,
          EXPERT_BACKED_RESEARCH = _this$staticData$CONS2.EXPERT_BACKED_RESEARCH,
          EXPERT_SURVEY_RESEARCH = _this$staticData$CONS2.EXPERT_SURVEY_RESEARCH;
      var ebresrQuestions = [{
        questionName: 'Project scope',
        question: 'Were your project needs well understood and met to your expectations throughout the duration of the project? (10 being highly understood, 1 not understood at all)'
      }, {
        questionName: 'Delivery speed',
        question: 'How satisfied were you with the speed of Atheneum expert sourcing? (10 being Extremely satisfied, 1 Extremely dissatisfied)'
      }, {
        questionName: 'Output quality',
        question: 'Were you satisfied with the final product delivered by Atheneum (10 being Extremely satisfied, 1 Extremely dissatisfied)'
      }, {
        questionName: 'Overall experience',
        question: 'How likely are you to recommend Atheneum to your colleagues or friends? (10 being Extremely likely, 1 Not at all likely)'
      }];
      var esepQuestions = [{
        questionName: 'Expert quality',
        question: 'How satisfied were you with the quality of Atheneum experts / market intelligence delivered to you? (10 being Extremely satisfied, 1 Extremely dissatisfied)'
      }, {
        questionName: 'Delivery speed',
        question: 'How satisfied were you with the speed of Atheneum expert sourcing? (10 being Extremely satisfied, 1 Extremely dissatisfied)'
      }, {
        questionName: 'Project handling',
        question: 'How satisfied were you with the handling of the project by Atheneum professionals in ensuring a smooth and timely delivery (10 being Extremely satisfied, 1 Extremely dissatisfied)'
      }, {
        questionName: 'Overall experience',
        question: 'How likely are you to recommend Atheneum to your colleagues or friends? (10 being Extremely likely, 1 Not at all likely)'
      }];
      return [EXPERT_BACKED_RESEARCH, EXPERT_SURVEY_RESEARCH].includes(projectType) ? ebresrQuestions : esepQuestions;
    }
  }]);

  return StaticData;
}();

var _default = new StaticData();

exports["default"] = _default;